import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export const FilterReferenceButton: React.FC<ButtonProps> = (props) => {
  const translate = useTypedTranslate();

  return (
    <Button
      {...props}
      color="secondary"
      label={translate('app.buttons.info')}
      startIcon={<InfoOutlinedIcon />}
      variant="text"
    />
  );
};
